import { render } from "./App.vue?vue&type=template&id=8685b6d6"
import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Sources/JavaScript/Extensions/Lfmpublications/Vue/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8685b6d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8685b6d6', __exports__)) {
    api.reload('8685b6d6', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=8685b6d6", () => {
    api.rerender('8685b6d6', render)
  })

}


export default __exports__